import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import environment from '../../environment';
import Html from './html';
import shared from './shared';

const AlreadyConnected = () => {
    const user = useSelector((state) => state.user);
    const [exclusions, setExclusions] = useState([]);
    const [groupMembers, setGroupMembers] = useState([]);
    const [stats, setStats] = useState(null);

    const activeGroup = user?.lastUsedGroupId || user?.groups?.find(g => g.status === 'active');
    const groupId = activeGroup?.groupId?._id || activeGroup?.groupId || activeGroup?._id || '';

    const isLeader = [
        environment.glRoleId,
        environment.assistantGlRoleId,
        environment.connectmeetmanagerRoleId,
    ].includes(user?.customerRole?._id);

    useEffect(() => {
        if (user && user.loggedIn && groupId) {
            getExclusions();
            getGroupMembers();
            if (isLeader) getStats();
        }
    }, [groupId]);

    const getExclusions = () => {
        ApiClient.get(shared.listApi, { userId: user._id, groupId }).then(res => {
            if (res.success) {
                setExclusions(res.data || []);
            }
        });
    };

    const getGroupMembers = () => {
        ApiClient.get(shared.membersApi, { groupId, isDeleted: false }).then(res => {
            if (res.success) {
                setGroupMembers(res.data || []);
            }
        });
    };

    const getStats = () => {
        ApiClient.get(shared.statsApi, { groupId }).then(res => {
            if (res.success) {
                setStats(res.data);
            }
        });
    };

    const addExclusion = (excludedUserId, reason) => {
        loader(true);
        ApiClient.post(shared.addApi, {
            userId: user._id,
            excludedUserId,
            groupId,
            reason,
        }).then(res => {
            if (res.success) {
                toast.success(res.message);
                getExclusions();
                if (isLeader) getStats();
            } else {
                toast.error(res.message);
            }
            loader(false);
        });
    };

    const removeExclusion = (id) => {
        Swal.fire({
            title: 'Remove from list?',
            text: 'This person may be assigned to your ConnectMeet again.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ea580c',
            confirmButtonText: 'Yes, remove',
        }).then((result) => {
            if (result.isConfirmed) {
                loader(true);
                ApiClient.put(shared.removeApi, {
                    id,
                    userId: user._id,
                }).then(res => {
                    if (res.success) {
                        toast.success(res.message);
                        getExclusions();
                        if (isLeader) getStats();
                    }
                    loader(false);
                });
            }
        });
    };

    return (
        <Html
            exclusions={exclusions}
            groupMembers={groupMembers}
            stats={stats}
            isLeader={isLeader}
            user={user}
            addExclusion={addExclusion}
            removeExclusion={removeExclusion}
        />
    );
};

export default AlreadyConnected;
